import { State, StateContext, Action, Store } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { ResetUserInfo, SetSalesPersonId, SetUserInfo } from './user.actions';
import { SetSalesPersonAction } from '@sales/states/order/order.actions';
import { DealerStateSelectors } from '@core/states/dealer/dealer-state.selectors';
import { User } from '@core/models/user.model';
import { patch } from '@ngxs/store/operators';

export interface UserStateModel {
  user: User;
  isAuthenticated: boolean;
}

const initialUserState = {
  user: {
    sub: '',
    name: '',
    given_name: '',
    family_name: '',
    role: [],
  } as User,
  isAuthenticated: false,
};

@State<UserStateModel>({
  name: 'user',
  defaults: initialUserState,
})
@Injectable()
export class UserState {
  private store = inject(Store);

  @Action(SetUserInfo)
  getUserInfo(ctx: StateContext<UserStateModel>, action: SetUserInfo) {
    const claims = action.userInfo.userClaims;
    ctx.setState(
      patch({
        user: patch({
          sub: claims.find(x => x.key === 'sub').value,
          name: claims.find(x => x.key === 'name').value,
          given_name: claims.find(x => x.key === 'given_name')?.value,
          family_name: claims.find(x => x.key === 'family_name')?.value,
          role: claims.filter(x => x.key === 'role')?.map(x => x.value),
        }),
        isAuthenticated: action.userInfo.isAuthenticated,
      })
    );
  }

  @Action(ResetUserInfo)
  resetUserInfo(ctx: StateContext<UserStateModel>) {
    ctx.setState(initialUserState);
  }

  @Action(SetSalesPersonId)
  public setUser(ctx: StateContext<UserStateModel>) {
    const state = ctx.getState();
    const canAdministerSellers = this.store.selectSnapshot(DealerStateSelectors.canAdministerSellers);
    if (!canAdministerSellers) {
      ctx.dispatch(new SetSalesPersonAction(state.user.sub));
    }
  }
}
